import React, { useEffect, useState } from 'react'
import SideModal from '../SideModal/SideModal'
import { Switch } from '@mui/material'
import { AdminService } from '../../services/admin.service'
import toast from 'react-hot-toast'

interface IBlockEnrollmentModal {
    show: any,
    handleClose: any
    data: any
}

const BlockEnrollmentModal = (props: IBlockEnrollmentModal) => {
    console.log(props);
    const [status, setStatus] = useState<boolean>(props.data==true ? true : false);

    useEffect(()=>{
        setStatus(props.data==true ? true : false);
    }, [props.data])

    const changeEnrollmentBlockStatus = async () =>{
        await AdminService.chnageEnrollmentBlockStatus(props.show, status).then((res)=>{
            if(res.status==200){
                toast.success("Enrollment updated");
            }
        })
        .catch((error)=>{
            toast.error("Something went wrong");
            console.log(error);
        })
    }

    return (
        <SideModal
            show={props.show != undefined ? true : false}
            handleClose={() => props.handleClose(undefined)}
            title="Block Enrollment"
            body={
                <>
                    <div>
                        <div>
                            Block Status : <Switch checked={status} onChange={(e)=>{setStatus(e.target.checked)}}/>
                        </div>
                        <div
                            className="btn btn-primary btn-block mb-4"
                            onClick={()=>{changeEnrollmentBlockStatus()}}
                        >
                            Save Enrollment
                        </div>
                    </div>
                </>
            }
        />
    )
}

export default BlockEnrollmentModal